import React from 'react';
import Mailto from 'react-mailto';

import bild from '../../design/photos/kontakt/NeuBig.jpg';

import styles from '../css/Main.css';
import Navigation from '../components/Navigation.js';

export default function KontaktAktuell() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.titleleft}>Hanna Schneider</p>
        <p className={styles.titleright}>Keramik</p>
      </div>
      <div className={styles.content2}>
        <div className={styles.kontakt}>
          <div className={styles.textBlock2}>
            <p className={styles.title}>Kontakt</p>
            <p className={styles.textBig}>Hanna Schneider</p>
            <p className={styles.textBig}>Birmensdorferstrasse 36</p>
            <p className={styles.textBig}>8953 Dietikon</p>
            <br />
            <p className={styles.textBig}>+41 44 272 80 06</p>
            <p className={styles.textBig}>+41 79 228 19 37</p>
            <Mailto className={styles.mailto} email="hannaschneider@bluewin.ch">
              <p className={styles.textBig}>hannaschneider@bluewin.ch</p>
            </Mailto>
          </div>
          <div className={styles.textBlock2}>
            <p className={styles.textBig}>Gerne können Sie mich nach Vereinbarung</p>
            <p className={styles.textBig}>in meinem Atelier besuchen.</p>
          </div>
        </div>
        <div className={styles.border} />
        <div className={styles.aktuell}>
          <div className={styles.textBlock2}>
            <p className={styles.title2}>Aktuell/Vorschau</p>
            {/*}
            <br />
            <br />
            <p className={styles.arialBig}>Design-Weihnachtsmarkt 2018</p>
            <p className={styles.textBig2}>In der Röslischüür</p>
            <p className={styles.textBig2}>Röslistrasse 9</p>
            <p className={styles.textBig2}>8006 Zürich</p>
            <br />
            <p className={styles.textBig2}>1.Dez 2018, 14.00-18.00 Uhr</p>
            <p className={styles.textBig2}>2.Dez.2018, 11.00-16.00 Uhr</p>
            <br />
            <a
              href="https://www.qkk6.ch/events/design-weihnachtsmarkt-2018/"
              className={styles.textBig2}
            >
              Zum Flyer
            </a>
            <br />
          </div>
          <div>
          
            <p className={styles.fett2}>Verkauf:</p>
          <br />
            <p className={styles.textBig3}>Brunngass Keramik</p>
            <p className={styles.textBig3}>Brunngasse 9, 8001 Zürich</p>
            <a
              href="http://www.brunngasskeramik.ch/"
              className={styles.fett2}
            >
              brunngasskeramik.ch
            </a>
          <br />
          <br />
          <br />
          <br />
          */}
            <p className={styles.textBig3}>regelmässige Teilnahme am</p>
            <a
              href="http://www.zuercher-keramikmarkt.ch"
              className={styles.fett2}
            >
              www.zuercher-keramikmarkt.ch
            </a>
            {/*<img alt={1} className={styles.photoKontakt} src={bild} />*/}
           
          </div>
        </div>
      </div>
      <Navigation />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/KontaktAktuell.js